/* eslint-disable */
import React, { useState, memo, useLayoutEffect, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import Paper, { PaperProps } from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { openContract } from '../../store/reducers/openContractSlice';

const useStyles = makeStyles({
 dialog: {
  height: '100%',
 },

 dialogContainer: {
  '& .MuiDialog-container': {
   justifyContent: 'center',
   justifyItems: 'center',
   display: 'flex',
   width: '100%',
   backgroundColor: 'none',
   overflow: 'hidden',
   height: '1000px',
  },
  '& .MuiTypography-root': {
   display: 'flex',
   alignItems: 'center',
  },
  '& .MuiDialogContent-root': {
   overflow: 'hidden',
   padding: '0 !important',
   margin: '0 !important',
  },
  '& .MuiDialog-paper': {
   height: '500px',
  },
 },
 dialogTitle: {
  height: '20px',
  border: '1px solid #cacaca',
  color: 'black !important',
 },
 container: {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  padding: 0,
  flexDirection: 'row',
 },
 headerTitle: {
  fontWeight: 'bold',
  color: 'white',
  fontSize: '16px',
  fontFamily: 'calibri',
  padding: '5px 40px',
  borderRadius: '10px',
 },
 banner: {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
 },
});

function PaperComponent(props: PaperProps) {
 return (
  <Draggable
   handle="#draggable-dialog-title"
   cancel={'[class*="MuiDialogContent-root"]'}
  >
   <Paper {...props} />
  </Draggable>
 );
}

/**
 * Окно банера.
 * @param props
 * @returns
 */
const DialogContract = (props: any) => {
 const classes = useStyles();
 const dispatch = useDispatch<AppDispatch>();

 const openContractData = useSelector(
  (state: RootState) => state.openContract,
  shallowEqual,
 );

 const closeDialogHandler = () => {
  dispatch(openContract(false));
 };

 return (
  <div>
   <Dialog
    className={classes.dialogContainer}
    open={openContractData}
    PaperComponent={PaperComponent}
    aria-labelledby="draggable-dialog-title"
    PaperProps={{
     sx: {
      width: '800px',
      height: '300px',
      maxWidth: '800px',
      overflow: 'auto',
      marginTop: '20px',
     },
    }}
   >
    <DialogTitle
     className={classes.dialogTitle}
     style={{
      cursor: 'move',
      backgroundColor: 'black',
      border: '1px black solid',
     }}
     id="draggable-dialog-title"
    >
     <div className={classes.container}>
      <div
       className={classes.headerTitle}
       style={{
        color: 'white',
        marginTop: '1px',
        marginLeft: '-40px',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
       }}
      >
       <div style={{ marginTop: '5px' }}>{'Оплата по СБП'}</div>
       <div
        style={{
         display: 'flex',
         flexDirection: 'row',
         marginLeft: '30px',
         marginTop: '7px',
        }}
       ></div>
      </div>

      <div style={{ cursor: 'pointer', marginTop: '5px' }}>
       <CloseIcon
        style={{
         marginTop: '8px',
         marginRight: '-15px',
         fontWeight: 800,
         color: 'white',
        }}
        onClick={closeDialogHandler}
       />
      </div>
     </div>
    </DialogTitle>
    <DialogContent className={classes.dialog}>
     <div>
      <div style={{ height: '100vh', width: '100%', zIndex: 10000 }}>
       {/* Use an iframe to load the external URL content */}
       {props.dialogContent ? props.dialogContent : <p>Loading content...</p>}
      </div>
     </div>
    </DialogContent>
   </Dialog>
  </div>
 );
};

export default memo(DialogContract);
